export const achievementData = {
    bio : "One of my key accomplishments was optimizing the email triggering processes through multi-threading in Spring Batch at Element Fleet Management. This initiative led to a 40% reduction in processing time and generated annual cost savings of $39,000, demonstrating my ability to enhance system performance and implement cost-efficient solutions.",
    achievements : [
        {
            id : 1,
            title : 'Java Enterprise Applications with DevOps - NIIT',
            details : 'This certification demonstrates my expertise in Java enterprise applications with a focus on DevOps practices, continuous integration, and continuous deployment for scalable enterprise systems.',
            },
        {
            id : 2,
            title : 'Java Certification - IIT Bombay',
            details : 'IIT Bombay’s Java Certification showcases my strong foundation in Java programming, covering core Java concepts, object-oriented programming, and real-world application development.',
              },
        {
            id : 3,
            title: 'TASK: Oracle Certified',
            details: 'As an Oracle Certified professional, I possess a deep understanding of Oracle technologies, database management, and enterprise-level application development.',
               }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/